import { render, staticRenderFns } from "./UploadImgs.vue?vue&type=template&id=dd59bb0a&scoped=true&"
import script from "./UploadImgs.vue?vue&type=script&lang=js&"
export * from "./UploadImgs.vue?vue&type=script&lang=js&"
import style0 from "./UploadImgs.vue?vue&type=style&index=0&id=dd59bb0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd59bb0a",
  null
  
)

export default component.exports